import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as DislikeIcon } from 'assets/images/dislike.svg';
import { ReactComponent as LikeIcon } from 'assets/images/like.svg';
import { ReactComponent as TipsIcon } from 'assets/images/tips.svg';
import { ReactComponent as LikedIcon } from 'assets/images/liked.svg';
import { useService } from 'common/hooks/useService';
import { EEventAction, EYandexMetrikaEvent } from 'common/const';
import { sendYandexMetrikaEvent } from 'common/helpers/yandex.helper';
import { getEventPayload } from 'common/helpers/event.helper';
import { IUser } from 'common/types/user.types';
import { IReviewParams } from 'common/types/metrika.types';

interface IComponentProps {
  user?: IUser | null;
  visitorUid: string | null;
  redirectUrl?: string;
  onDislikeClick: () => void;
  onLeaveTipsClick: () => void;
  /** Параметры воронки экрана оценки для «Да»; без полученного заведения - undefined (metrika-funnel, R-8). */
  metrikaParams?: IReviewParams;
}

export const Review: FC<IComponentProps> = ({
  user,
  visitorUid,
  redirectUrl,
  onDislikeClick,
  onLeaveTipsClick,
  metrikaParams,
}) => {
  const [isLiked, setIsLiked] = useState<boolean>(false);
  const { Service } = useService();
  const { t } = useTranslation();

  const eventPayload = getEventPayload(visitorUid, user?.id);

  const onLikeClick = () => {
    Service.sendEvent({ ...eventPayload, action: EEventAction.Like });
    sendYandexMetrikaEvent(EYandexMetrikaEvent.LikeButtonClick, metrikaParams);
    setIsLiked(true);
    redirectUrl && window.open(redirectUrl, '_blank', 'noopener,noreferrer');
  };

  if (isLiked) {
    return (
      <div>
        <div className="review__container">
          <LikedIcon />

          <div className="review__description">
            <div>{t('review.thankYou')}</div>

            <div>{t('review.youCanStillLeaveTip')}</div>
          </div>
        </div>

        <div className="btn btn-submit">
          <button onClick={onLeaveTipsClick}>
            <TipsIcon />

            <span>{t('review.leaveTips')}</span>
          </button>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="review__container">
        <div>{t('review.didYouLike')}</div>

        <div className="review__btns">
          <button className="review__btn" onClick={onDislikeClick}>
            <DislikeIcon />

            <span>{t('review.dislike')}</span>
          </button>

          <button className="review__btn" onClick={onLikeClick}>
            <LikeIcon />

            <span>{t('review.like')}</span>
          </button>
        </div>
      </div>

      <div className="review__divider">{t('review.or')}</div>

      <div className="review__tips">
        <div className="review__tips-description">{t('review.youCanAlsoLeaveTips')}</div>

        <div className="btn btn-default">
          <button onClick={onLeaveTipsClick} disabled={!user?.filled_in_all_bank_details}>
            <TipsIcon />

            <span>{t('review.tip')}</span>
          </button>
        </div>
      </div>
    </div>
  );
};
